import { ErrorHandler, Injectable } from "@angular/core"

import { environment } from "../environments/environment"

@Injectable()
export class LoggerService implements ErrorHandler {
  private sentry_enabled = false

  constructor() {
    if (environment.sentry_url && Raven) {
      const sentry_options = {
        tags: {
          application: "quick-feedback"
        },
        ignoreErrors: [
          // These errors are raised by firefox in private browsing mode when we try to open indexedDB
          // Try/catch around indexedDB.open() doesn't handle the exception
          /^InvalidStateError$/i,
          /^UnknownError$/i
        ]
      }

      Raven.config(environment.sentry_url, sentry_options).install()

      this.sentry_enabled = true
    }

    // Add listener for unhandled Promise rejections.
    // --
    // NOTE: At the time of this writing, only Chrome has native support for this
    // global event. Other browser may or may not log the root Error to the console,
    // but the behavior differs depending on the Promise implementation (ie, native
    // vs. shim).
    window.addEventListener("unhandledrejection", (event: any) => {
      // Prevent the default behavior, which is logging the unhandled rejection
      // error to the console.
      // --
      // NOTE: This is only meaningful in Chrome that supports this event.
      event.preventDefault()

      this.handleError(event.reason, { is_promise: true })
    })
  }

  public handleError(error: Error, extra?: { [key: string]: any }) {
    if (this.sentry_enabled) {
      Raven.captureException(error, { extra: extra })
    }

    console.error(error.name, extra, error.stack)
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/logger.service.ts